import React from 'react';

import { Button } from '@repo/ui/components/Buttons';

import {
  CardDivider,
  FooterWrapper,
} from 'components/AiTools/RigthPanel/styles';
import { FooterProps } from 'components/AiTools/RigthPanel/types';

const Footer: React.FC<FooterProps> = ({
  isLoading,
  isDisabled,
  buttonIcon,
  buttonLabel,
  onClick,
  small,
}) => {
  return (
    <>
      <CardDivider />
      <FooterWrapper small={!!small}>
        <Button
          appendIcon
          disabled={isDisabled}
          icon={
            buttonIcon
              ? {
                  component: () => buttonIcon,
                }
              : undefined
          }
          label={buttonLabel}
          loading={isLoading}
          name="footerActionButton"
          style={{
            marginLeft: 'auto',
            whiteSpace: 'nowrap',
          }}
          width={small ? '100%' : 'unset'}
          onClick={onClick}
        />
      </FooterWrapper>
    </>
  );
};

export default Footer;
